import { Link } from "react-router-dom";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ crumbs, dir }) {
  const Sep = () => <ChevronRight size={14} className={`text-faint ${dir === "rtl" ? "rotate-180" : ""}`} />;
  return (
    <nav aria-label="breadcrumb" data-testid="breadcrumbs" className="flex items-center gap-2 text-xs text-subtle flex-wrap">
      {crumbs.map((c, i) => (
        <span key={i} className="flex items-center gap-2">
          {c.path && i < crumbs.length - 1 ? (
            <Link to={c.path.replace(/\/$/, "") || c.path} className="hover:text-copper transition-colors">{c.name}</Link>
          ) : (
            <span className="text-ink/70">{c.name}</span>
          )}
          {i < crumbs.length - 1 && <Sep />}
        </span>
      ))}
    </nav>
  );
}

export function FaqSection({ faq, title }) {
  if (!faq || faq.length === 0) return null;
  return (
    <section className="mt-14" data-testid="faq-section">
      <h2 className="text-2xl sm:text-3xl font-bold uppercase tracking-tight text-ink mb-6">{title}</h2>
      <Accordion type="single" collapsible className="max-w-3xl">
        {faq.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-ink text-base py-5 hover:no-underline hover:text-copper">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-subtle text-sm leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}

export function ContentSections({ sections }) {
  if (!sections || sections.length === 0) return null;
  return (
    <div className="mt-10 space-y-10 max-w-3xl">
      {sections.map((s, i) => (
        <section key={i} data-testid={`content-section-${i}`}>
          <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-ink mb-3">{s.h2}</h2>
          <p className="text-subtle leading-relaxed">{s.body}</p>
        </section>
      ))}
    </div>
  );
}
